<template>
  <form-wizard ref="uploadwizard" 
    color="#5369f8" 
    error-color="#ff5c75"
    :next-button-text="$t('common.upload_resume.next_button')"
    :back-button-text="$t('common.upload_resume.back_button')"
    :finish-button-text="$t('common.upload_resume.finish_button')"
    @on-complete="onComplete"
  >

    <tab-content
      :title="$t('common.upload_resume.steps.step1.title')"
      :before-change="() => validateStep('step0')"
    >
      <Step0 
        ref="step0" 
        @on-validate="mergePartialModels"
      />
    </tab-content>

    <tab-content
      :title="$t('common.upload_resume.steps.step2.title')"
      :before-change="() => validateStep('step1')"
    >
      <Step1 
        ref="step1" 
        :data="finalModel.user" 
        @on-validate="mergePartialModels" 
        @close-error-modal="mergePartialModels({}, null, true)"
      />
    </tab-content>

    <tab-content
      :title="$t('common.upload_resume.steps.step3.title')"
      :before-change="() => validateStep('step2')"
    >
      <Step2 
        ref="step2" 
        :data="finalModel.work_experiences" 
        @on-validate="mergePartialModels" 
      />
    </tab-content>
    <tab-content
      :title="$t('common.upload_resume.steps.step4.title')"
      :before-change="() => validateStep('step3')"
    >
      <Step3
        ref="step3"
        :data="finalModel.educations"  
        @on-validate="mergePartialModels" 
      />
    </tab-content>
    <tab-content
      :title="$t('common.upload_resume.steps.step5.title')"
      :before-change="() => validateStep('step4')"
    >
      <Step4 
        ref="step4" 
        :data="finalModel.skills" 
        @on-validate="mergePartialModels" 
      />
    </tab-content>
    <tab-content 
      :title="$t('common.upload_resume.steps.step6.title')"
      :before-change="() => validateStep('step5')"
    >
      <Step5 
        ref="step5" 
        :data="finalModel" 
        @on-validate="mergePartialModels" 
      />
    </tab-content>
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import Step0 from '../steps/step0.vue'
import Step1 from '../steps/step1.vue'
import Step2 from '../steps/step2.vue'
import Step3 from '../steps/step3.vue'
import Step4 from '../steps/step4.vue'
import Step5 from '../steps/step5.vue'

export default {
  components: {
    FormWizard,
    TabContent,
    Step0,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    finalModel() {
      let parameters = this.parameters || {}
      return parameters.finalModel || {}
    },
    resetWizard() {
      let parameters = this.parameters || {}
      return parameters.is_reset_wizard
    }
  },
  methods: {
    validateStep(name) {
			var refToValidate = this.$refs[name]
			return refToValidate.validate()
		},
    mergePartialModels(model, isValid, showError = false) {
      if(!showError){
        if (isValid && model) {
          this.$emit('onClick', { method: 'mergePartialModels', model, isValid, showError })
        }
      }
      else {
        this.$emit('onClick', { method: 'closeAllModals' })
      }
    },
    onComplete() {
      this.$emit('onClick', { method: 'onComplete' })
    },
    onResetWizard(){
      let wiz = this.manual ? ['manual_step2'] : ['step0']
      
      for(var key in wiz){
        var refToValidate = this.$refs[wiz[key]]
        refToValidate.reset()
      }
    },
  },
  watch: {
    resetWizard () {
      this.onResetWizard()
    }
  }
}
</script>